
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.333h513v342H0z"}}),_c('path',{attrs:{"fill":"#f4d900","d":"M0 323.333h513v104H0z"}}),_c('path',{attrs:{"fill":"#006d66","d":"M0 85.333h513v104H0z"}}),_c('path',{attrs:{"d":"M0 204.333h513v104H0z"}}),_c('path',{attrs:{"fill":"#cb0f31","d":"M256 256.006L0 426.668V85.331z"}}),_c('path',{attrs:{"fill":"#f4d900","d":"M83.477 195.132l15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"}})])
          )
        }
      }
    